<template>
  <div class="f-facial-header-wrapper">
    <div class="d-flex flex-grow-1" style="height: 100%; padding: 4rem">
      <b-card style="width: 100%; height: 100%" class="box-back-white"
        >hi</b-card
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.f-facial-header-wrapper {
  height: calc(100vh - 76px);
  background-color: #0d0d0d;
  background-image: linear-gradient(315deg, #0d0d0d 0%, #0d0d0d 74%);
}
.text-gradient-blue {
  font-size: 72px;
  background-image: linear-gradient(
    45deg,
    rgb(37, 47, 255) -100%,
    rgb(37, 106, 243) -50%,
    rgb(124, 192, 226) 0%,
    rgb(37, 106, 243) 50%,
    rgb(37, 47, 255) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.box-back-white {
  border-radius: 50px;
  background: #0d0d0d;
  box-shadow: 11px 11px 18px #050505, -11px -11px 18px #151515;
}
</style>


// WEBPACK FOOTER //
// src/components/featured/facial.vue